// src/components/concerns/ConcernsSection.js
import React, { useState, useEffect } from 'react';
import './ConcernsSection.css';
import './MobileConcernsSection.css'; // Import mobile-specific styles

const ConcernsSection = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  return (
    <section className="concerns-section">
      {/* Background image - using img instead of background-image */}
      <img 
        src={`${process.env.PUBLIC_URL}/images/nayami.png`}
        alt="Background"
        className="concerns-bg"
      />
      
      <div className="concerns-container">
        {/* Upper Box - Existing Code */}
        <div className="upperbox">
          <div className="frame-217">
            <div className="frame-206">
              {/* Title part with 悩み */}
              <div className="ttl">
                <div className="frame-207">
                  <div className="ellipse-1">
                    <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
                      <circle cx="4" cy="4" r="4" fill="#F4792B"/>
                    </svg>
                  </div>
                  <div className="ellipse-2">
                    <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
                      <circle cx="4" cy="4" r="4" fill="#F4792B"/>
                    </svg>
                  </div>
                  <div className="ellipse-3">
                    <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
                      <circle cx="4" cy="4" r="4" fill="#F4792B"/>
                    </svg>
                  </div>
                </div>
                <div className="concerns-title">こんなお悩みありませんか？</div>
              </div>
              
              {/* Line divider */}
              <div className="group-1">
                <div className="line-1"></div>
                <div className="line-diagonal"></div>
                <div className="line-2"></div>
              </div>
            </div>
            
            {/* List of concerns */}
            <div className="frame-216">
              {/* Concern Item 1 */}
              <div className="concern-item">
                <div className="checkbox">
                  <svg xmlns="http://www.w3.org/2000/svg" width="29" height="28" viewBox="0 0 29 28" fill="none">
                    <rect x="1" y="4" width="23" height="23" stroke="#5A4C49" stroke-width="2"/>
                    <path d="M27 2L13.1473 18.9662" stroke="#F4792B" stroke-width="4" stroke-linecap="round"/>
                    <path d="M5 11L13 19" stroke="#F4792B" stroke-width="4" stroke-linecap="round"/>
                  </svg>
                </div>
                <div className="concern-text-container">
                  <div className="concern-text">
                    現在、<span className="highlighted-text">住む場所がない…</span>
                  </div>
                </div>
              </div>
              
              {/* Concern Item 2 */}
              <div className="concern-item">
                <div className="checkbox">
                  <svg xmlns="http://www.w3.org/2000/svg" width="29" height="28" viewBox="0 0 29 28" fill="none">
                    <rect x="1" y="4" width="23" height="23" stroke="#5A4C49" stroke-width="2"/>
                    <path d="M27 2L13.1473 18.9662" stroke="#F4792B" stroke-width="4" stroke-linecap="round"/>
                    <path d="M5 11L13 19" stroke="#F4792B" stroke-width="4" stroke-linecap="round"/>
                  </svg>
                </div>
                <div className="concern-text-container">
                  <div className="concern-text">
                    生活保護の申請を <span className="highlighted-text">過去に断られた…</span>
                  </div>
                </div>
              </div>
              
              {/* Concern Item 3 */}
              <div className="concern-item">
                <div className="checkbox">
                  <svg xmlns="http://www.w3.org/2000/svg" width="29" height="28" viewBox="0 0 29 28" fill="none">
                    <rect x="1" y="4" width="23" height="23" stroke="#5A4C49" stroke-width="2"/>
                    <path d="M27 2L13.1473 18.9662" stroke="#F4792B" stroke-width="4" stroke-linecap="round"/>
                    <path d="M5 11L13 19" stroke="#F4792B" stroke-width="4" stroke-linecap="round"/>
                  </svg>
                </div>
                <div className="concern-text-container">
                  <div className="concern-text">
                    所持金が少なく、<span className="highlighted-text">食事にも困っている…</span>
                  </div>
                </div>
              </div>
              
              {/* Concern Item 4 */}
              <div className="concern-item">
                <div className="checkbox">
                  <svg xmlns="http://www.w3.org/2000/svg" width="29" height="28" viewBox="0 0 29 28" fill="none">
                    <rect x="1" y="4" width="23" height="23" stroke="#5A4C49" stroke-width="2"/>
                    <path d="M27 2L13.1473 18.9662" stroke="#F4792B" stroke-width="4" stroke-linecap="round"/>
                    <path d="M5 11L13 19" stroke="#F4792B" stroke-width="4" stroke-linecap="round"/>
                  </svg>
                </div>
                <div className="concern-text-container">
                  <div className="concern-text">
                    <span className="highlighted-text">頼れる人がいない…</span>
                  </div>
                </div>
              </div>
              
              {/* Concern Item 5 */}
              <div className="concern-item">
                <div className="checkbox">
                  <svg xmlns="http://www.w3.org/2000/svg" width="29" height="28" viewBox="0 0 29 28" fill="none">
                    <rect x="1" y="4" width="23" height="23" stroke="#5A4C49" stroke-width="2"/>
                    <path d="M27 2L13.1473 18.9662" stroke="#F4792B" stroke-width="4" stroke-linecap="round"/>
                    <path d="M5 11L13 19" stroke="#F4792B" stroke-width="4" stroke-linecap="round"/>
                  </svg>
                </div>
                <div className="concern-text-container">
                  <div className="concern-text">
                    早く<span className="highlighted-text">快適な部屋</span>に住みたい…
                  </div>
                </div>
              </div>
              
              {/* Concern Item 6 */}
              <div className="concern-item">
                <div className="checkbox">
                  <svg xmlns="http://www.w3.org/2000/svg" width="29" height="28" viewBox="0 0 29 28" fill="none">
                    <rect x="1" y="4" width="23" height="23" stroke="#5A4C49" stroke-width="2"/>
                    <path d="M27 2L13.1473 18.9662" stroke="#F4792B" stroke-width="4" stroke-linecap="round"/>
                    <path d="M5 11L13 19" stroke="#F4792B" stroke-width="4" stroke-linecap="round"/>
                  </svg>
                </div>
                <div className="concern-text-container">
                  <div className="concern-text">
                    <span className="highlighted-text">体調が悪く、持病がある…</span>
                  </div>
                </div>
              </div>
              
              {/* Concern Item 7 */}
              <div className="concern-item">
                <div className="checkbox">
                  <svg xmlns="http://www.w3.org/2000/svg" width="29" height="28" viewBox="0 0 29 28" fill="none">
                    <rect x="1" y="4" width="23" height="23" stroke="#5A4C49" stroke-width="2"/>
                    <path d="M27 2L13.1473 18.9662" stroke="#F4792B" stroke-width="4" stroke-linecap="round"/>
                    <path d="M5 11L13 19" stroke="#F4792B" stroke-width="4" stroke-linecap="round"/>
                  </svg>
                </div>
                <div className="concern-text-container">
                  <div className="concern-text">
                    生活保護の申請が不安で<span className="highlighted-text"> 1人で行くのが怖い。</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        {/* Frame 221 - Below Upper Box */}
        <div className="frame-221">
          <div className="ttl-container">
            <div className="frame-220">
              <div className="frame-219">
                <div className="frame-128">
                  <div className="rectangle-111">
                    <div className="polygon-2">
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="18" viewBox="0 0 20 18" fill="none">
                        <path d="M9.14344 16.5782C9.53219 17.2235 10.4678 17.2235 10.8566 16.5782L19.479 2.26604C19.8805 1.59955 19.4005 0.75 18.6224 0.75H1.3776C0.599504 0.75 0.119507 1.59955 0.521037 2.26604L9.14344 16.5782Z" fill="#F4792B"/>
                      </svg>
                    </div>
                  </div>
                </div>
                <div className="support-for-you">そんなあなたのために</div>
              </div>
              <div className="concern-title-text">
                <div className="support-title">
                  <div className="first-line">
                    <span className="highlight-orange">生活保護</span>の<span className="highlight-orange">申請</span>から<span className="highlight-orange">住まい探し</span>まで、
                  </div>
                  <div className="second-line">
                    <div className="rectangle-27"></div>
                    <div className="highlight-rectangle">すべて無料でサポートします！</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          {/* Frame 48098559 - Photo */}
          <div className="frame-48098559">
            <div className="concern-photo">
              <img 
                src={`${process.env.PUBLIC_URL}/images/${isMobile ? 'concern_mobile.png' : 'concern_desktop.png'}`} 
                alt="Support services" 
                className="concern-photo-img"
                style={{ maxWidth: '100%', height: 'auto' }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ConcernsSection;